import Skeleton from "react-loading-skeleton"
import "react-loading-skeleton/dist/skeleton.css"

interface ISkeletonLoader {
 count?: number
}
export const SkeletonLoader = ({ count }: ISkeletonLoader) => {
 return (
  <div className="w-full mt-8 mx-auto">
   <Skeleton className="py-1 my-1 w-full" count={count} />
  </div>
 )
}
